module.exports = __webpack_public_path__ + "img/SG.9f1f2806.png";